// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordInput":"reset-password-form_resetPasswordInput__o27Hd"};